const ADMIN_GROUPS = new Set([
  'admin',
  'authentik Admins',
  'App Admin'
].map((group) => group.toLowerCase()));

export function hasAdminAccess(user) {
  if (!user) {
    return false;
  }

  return (user.groups ?? []).some((group) => {
    if (typeof group !== 'string') {
      return false;
    }

    return ADMIN_GROUPS.has(group.trim().toLowerCase());
  });
}
